import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

const AsyncCourse = Load(
  () =>
    import(
      /* webpackChunkName: "course-page" */ './containers/CourseContainer'
    ),
);

export const courseRoute: RouteDescriptor = {
  id: 'course.detail',
  path: `${basePath}/course/:id/*`,
  label: 'Course Detail',
  audience: 'both',
  layout: 'navigational',
  module: 'course',
};

export const courseRoutes = [
  createNavigationalRoute({
    key: courseRoute.id,
    id: courseRoute.id,
    path: courseRoute.path,
    component: AsyncCourse,
    handle: createRouteHandle(courseRoute),
    hideFooter: true,
    showSearchInNavbar: false,
    nonFixedNavbar: true,
  }),
];

export const courseRouteDescriptors = [courseRoute];

export default courseRoutes;
